export enum ENumberProducts {
  leedpulse = 'leedpulse',
  leedflow = 'leedflow',
  all = 'all',
}

export const numberProductsAsString = (
  numberProducts: ENumberProducts
): string => {
  switch (numberProducts) {
    case ENumberProducts.leedpulse:
      return 'Leedpulse';
    case ENumberProducts.leedflow:
      return 'Leedflow';
    case ENumberProducts.all:
      return 'Tous';
  }
};